import React, { useState } from 'react';
import { Cookie, X } from 'lucide-react';
import './notifications/premiumToast.css';

// Bump this version whenever the cookie practices / policy text change —
// the notice will re-appear once for every user until re-acknowledged.
export const COOKIE_NOTICE_VERSION = '1';
const STORAGE_KEY = 'tf-cookie-notice-ack';

const readAck = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

const writeAck = () => {
  try {
    window.localStorage.setItem(STORAGE_KEY, COOKIE_NOTICE_VERSION);
  } catch {
    // Storage unavailable (private mode) — notice will simply re-appear.
  }
};

export const CookieNotice = () => {
  // PREMIUM-NOTIFY-001 — informational notice. Cookie audit (Oct 2026): the backend sets only the HttpOnly
  // `access_token` / `refresh_token` session cookies (strictly necessary for sign-in); all other state is
  // browser localStorage UI preference. No analytics / marketing cookies → no consent toggles required;
  // "Manage" opens the Cookie Policy where the essential cookies are documented.
  const [visible, setVisible] = useState(() => readAck() !== COOKIE_NOTICE_VERSION);
  if (!visible) return null;

  const handleAcknowledge = () => {
    writeAck();
    setVisible(false);
  };

  return (
    <div role="region" aria-label="Cookie notice" className="tf-cookie" data-testid="cookie-notice">
      <div className="tf-cookie-icon" aria-hidden="true"><Cookie className="w-5 h-5" /></div>
      <div className="tf-cookie-text">
        <div className="tf-cookie-title">We use essential cookies to keep TitleFlow secure and working properly.</div>
        <div className="tf-cookie-body">
          Only strictly necessary sign-in cookies are used — no tracking or advertising. For more information, please review our{' '}
          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" data-testid="cookie-notice-privacy-link">Privacy Policy</a> and{' '}
          <a href="/cookie-policy" target="_blank" rel="noopener noreferrer" data-testid="cookie-notice-policy-link">Cookie Policy</a>.
        </div>
      </div>
      <div className="tf-cookie-actions">
        <a href="/cookie-policy" target="_blank" rel="noopener noreferrer" className="tf-cookie-btn tf-cookie-btn--ghost inline-flex items-center" data-testid="cookie-notice-manage-btn">Manage</a>
        <button type="button" onClick={handleAcknowledge} className="tf-cookie-btn tf-cookie-btn--primary" data-testid="cookie-notice-accept-btn">Got It</button>
        <button type="button" onClick={handleAcknowledge} className="tf-cookie-close" aria-label="Dismiss cookie notice" data-testid="cookie-notice-dismiss-btn"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
};

export default CookieNotice;
